import TableCard from "../tableCard/TableCard";
import { useState, useEffect, useContext } from "react";
import { TimeStampToJalali } from "../../utils/helperFunction";
import { addCommas } from "@persian-tools/persian-tools";
import { EditIcon } from "../kits/Icons";
import { MdOutlineChangeCircle } from "react-icons/md";
import { BsPrinter } from "react-icons/bs";
import CustomButton from "../kits/button/CustomButton";
import { NavLink } from "react-router-dom";
import ColorSchema from "../kits/Color";
import { CustomTooltip } from "../kits/tooltip/CustomTooltip";
import { ReactSelect } from "../kits/Inputs/Inputs";
import AuthenticationContext from "../../Authentication/AuthenticationContext.ts";

import useAxios from "../../services/useAxios";
export default function OrderList({ orderDataList, setUpdate, type = "sell" }) {
  const { userInfo } = useContext(AuthenticationContext);

  console.log("orderDataList", orderDataList);
  const orderStatus = [
    { label: "پیش فاکتور", value: "-1" },
    { value: "0", label: "در انتظار ورود به تولید" },
    { value: "1", label: "در انتظار مواد اولیه" },
    { value: "2", label: "در حال تولید" },
    { value: "3", label: "تولید شده" },
    { value: "4", label: "منتظر ارسال" },
  ];
  const { loading, execute: changeStatus } = useAxios("api/Update_orders");

  const [content, setContent] = useState([
    // {
    //   customer_name: (
    //     <div style={{ whiteSpace: "break-spaces" }}>
    //       فروشگاه کت و شلوار پاریس
    //     </div>
    //   ),
    //   user_name: "رضا قادری",
    //   items: [
    //     { title: "فلت بگ 45 در65", count: "1000" },
    //     { title: "دسته بندی", count: "1000" },
    //     { title: "ضرب چاپ 3 عدد", count: "1000" },
    //   ],
    //   total_price: "6700000",
    //   mtm: "1675317240",
    //   status: "0",
    // },
    // {
    //   customer_name: "چینی مقصودی",
    //   user_name: "هوشنگ صدرا",
    //   items: [{ title: "کوله پشتی", count: "1500" }],
    //   total_price: "3000000",
    //   mtm: "1671317240",
    //   status: "-1",
    // },
  ]);
  const [header, setHeader] = useState([]);
  const itemsText = (array) => {
    return array?.map((v, i) => {
      return (
        <>
          <div style={{ lineHeight: 1.4 }}>
            {v.title}({v.count}&nbsp;عدد){array.length != i + 1 ? "," : ""}
          </div>
          {v.OptionOrderItem?.map((val) => {
            return (
              <>
                {val[0]?.title}({val.value[0]?.value?.name})
              </>
            );
          })}
        </>
      );
    });
  };
  const operations = (value) => {
    return (
      <div className="d-flex align-items-center justify-content-evenly">
        {userInfo.userRoll.includes(17) && (
          <CustomTooltip title="ویرایش" placement="top" color="dark_custom">
            <div>
              <NavLink
                to={`/order/${value.id}`}
                // target="_blank"
                style={{
                  width: "20px",
                  height: "20px",
                  textDecoration: "none",
                  color: ColorSchema.dark_custom,
                }}
                className="cursor-pointer"
              >
                <EditIcon containerIconClassName="cursor-pointer" />
              </NavLink>
            </div>
          </CustomTooltip>
        )}
        {/* <CustomTooltip title="تغییر وضعیت" placement="top" color="dark_custom">
          <div
            style={{ width: "22px", height: "22px" }}
            className="cursor-pointer"
          >
            <MdOutlineChangeCircle style={{ width: "100%", height: "100%" }} />
          </div>
        </CustomTooltip> */}
        {userInfo.userRoll.includes(18) && (
          <CustomTooltip title="فاکتور" placement="top" color="dark_custom">
            <div>
              <NavLink
                to={`/factor/${value.id}`}
                // target="_blank"
                style={{
                  width: "20px",
                  height: "20px",
                  textDecoration: "none",
                  color: ColorSchema.dark_custom,
                }}
                className="cursor-pointer"
              >
                <BsPrinter style={{ width: "100%", height: "100%" }} />
              </NavLink>
            </div>
          </CustomTooltip>
        )}
      </div>
    );
  };
  const changeOrderStatusFunc = (orderId, statusNumber) => {
    changeStatus({
      conditions: `id/=/${orderId}`,
      keyvalues: `status,${statusNumber}`,
    }).then((result) => {
      if (result.status == 1) {
        setUpdate((prev) => !prev);
      }
    });
  };
  useEffect(() => {
    orderDataList != undefined && setContent(orderDataList);
  }, [orderDataList]);
  useEffect(() => {
    let array = header;

    if (type == "sell")
      array = [
        {
          type: "title",
          title: "نام مشتری",
          name: "customerName",
        },
        {
          type: "user",
          title: "نام رابط",
          name: "user_name",
        },
        {
          type: "description",
          title: "آیتمها",
          name: "items",
        },
        {
          type: "title",
          title: "مبلغ کل(تومان)",
          name: "total_price",
        },
        {
          type: "title",
          title: "تاریخ سفارش",
          name: "mtm",
        },

        {
          type: "title",
          title: "عملیات",
          name: "operation",
        },
      ];
    else if (type == "buy")
      array = [
        {
          type: "title",
          title: "نام مشتری",
          name: "customerName",
        },
        {
          type: "description",
          title: "آیتمها",
          name: "items",
        },
        {
          type: "title",
          title: "مبلغ کل(تومان)",
          name: "total_price",
        },
        {
          type: "title",
          title: "تاریخ سفارش",
          name: "mtm",
        },

        {
          type: "title",
          title: "عملیات",
          name: "operation",
        },
      ];
    if (userInfo.userRoll.includes(19)) {
      array.push({
        type: "title",
        title: "وضعیت",
        name: "change_status",
      });
    }
    setHeader(array);
  }, [type]);

  console.log(content, "content");
  return (
    <div>
      {content?.map((value, index) => {
        console.log("content", value);
        return (
          <TableCard
            column={header}
            content={{
              ...value,
              items: itemsText(value.order_items),
              mtm: TimeStampToJalali(parseInt(value.mtm) * 1000),
              total_price: addCommas(value.total_amount),
              operation: operations(value),
              change_status: (
                <ReactSelect
                  itemsList={orderStatus}
                  inputValue={orderStatus.filter(
                    (v) => v.value == value.status
                  )}
                  onChangeFunc={(e) => changeOrderStatusFunc(value.id, e.value)}
                  id="titleTour"
                  title=""
                  inputSize="lg"
                  type="text"
                />
              ),
              customerName: (
                <div style={{ lineHeight: 1.5 }}>
                  {value.customer?.corporate == "1"
                    ? `${value.customer?.company_name}(${value.customer?.firstname} ${value.customer?.lastname})`
                    : `${value.customer?.firstname} ${value.customer?.lastname}`}
                </div>
              ),
              user_name: <div>{value?.customer?.main_uid?.fullname}</div>,
            }}
            bg={"dark_light_custom"}
            widthParent={"90%"}
            showSelect="false"
          ></TableCard>
        );
      })}
    </div>
  );
}
